(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/utils"] = factory();
	else
		root["@makolab/library-react/dist/utils"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 104);
/******/ })
/************************************************************************/
/******/ ({

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "randomId", function() { return randomId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shortRandomId", function() { return shortRandomId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseRootingParams", function() { return parseRootingParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pickParamsForRequest", function() { return pickParamsForRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNativeValue", function() { return setNativeValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "triggerOnChange", function() { return triggerOnChange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_pick__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forOwn__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forOwn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forOwn__);
// random string
/**
 * @returns {string} - random string, good for random id string, about 10-11 characters
 */var randomId=function randomId(){return Math.random().toString(36).substring(2);};/**
 * @returns {string} - random string, good for random id string, about 4-5 characters
 */var shortRandomId=function shortRandomId(){return randomId().substring(6);};/**
 *
 * @param {Object} params - object with routing params
 * @returns {Array} - parsed params object to array of objects {key, value}
 */var parseRootingParams=function parseRootingParams(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var rootingParams=[];__WEBPACK_IMPORTED_MODULE_1_lodash_forOwn___default()(params,function(v,k){rootingParams.push({key:k,value:v});});return rootingParams;};/**
 * @param {Object} options - options for this function
 * @param {Object} [options.additionalData] - object of key-value pairs used, some kind of data
 * @param {Object} options.routerParams - object of key-value pairs used, preferably from this.props.match.params,
 * those have higher priority than "additionalData"
 * @param {[String]} options.requiredParams - in return of this function, provide only those params with names, that matches string values in this list.
 * @returns {Object} - merged params from two sources, filtered with required key names
 */var pickParamsForRequest=function pickParamsForRequest(_ref){var _ref$additionalData=_ref.additionalData,additionalData=_ref$additionalData===undefined?{}:_ref$additionalData,_ref$routerParams=_ref.routerParams,routerParams=_ref$routerParams===undefined?{}:_ref$routerParams,_ref$requiredParams=_ref.requiredParams,requiredParams=_ref$requiredParams===undefined?[]:_ref$requiredParams;var data=Object.assign({},routerParams,additionalData);if(requiredParams.length){return __WEBPACK_IMPORTED_MODULE_0_lodash_pick___default()(data,requiredParams);}return data;};/**
 * Allows programmatically set value of input and trigger onchange event in react
 * @see https://github.com/facebook/react/issues/11095
 * @see https://jsfiddle.net/oavm1px8/
 * @param {HTMLElement} element - element to set value for
 * @param {*} value - value to set
 */var setNativeValue=function setNativeValue(element,value){var valueSetter=Object.getOwnPropertyDescriptor(element,'value').set;var prototype=Object.getPrototypeOf(element);var prototypeValueSetter=Object.getOwnPropertyDescriptor(prototype,'value').set;if(valueSetter&&valueSetter!==prototypeValueSetter){prototypeValueSetter.call(element,value);}else{valueSetter.call(element,value);}element.dispatchEvent(new Event('input',{bubbles:true}));};/**
 * Allows programmatically trigger onchange event in react
 * @see https://github.com/facebook/react/issues/11095
 * @see https://jsfiddle.net/oavm1px8/
 * @param {HTMLElement} element - element to set value for
 */var triggerOnChange=function triggerOnChange(element){element.dispatchEvent(new Event('input',{bubbles:true}));};

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

module.exports = require("lodash/pick");

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

module.exports = require("lodash/forOwn");

/***/ })

/******/ });
});
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/utils.js
// module id = 93
// module chunks = 0